var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-addEdit',{attrs:{"formList":_vm.formList,"formKey":_vm.formKey,"addParam":_vm.addParam,"editParam":_vm.editParam,"detailParam":_vm.detailParam},scopedSlots:_vm._u([{key:"gps",fn:function(ref){
var formItem = ref.formItem;
return [_c('x-location',{attrs:{"form":_vm.$children[0].form,"inputKey":_vm.inputKey,"position":_vm.position,"locationData":formItem}})]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-3de9c089","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/property/company/addCompany.vue
// module id = null
// module chunks = 